// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import TextFormField, {
    TextFormFieldProps,
    TextFormFieldPresentationProps,
} from "@store/Library/Components/FormField/TextFormField";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

export const lastNameFormFieldLabelKey = "Last Name";

export interface LastNameFormFieldPresentationProps extends ExpandStyles<LastNameFormFieldStyles> {}

export interface LastNameFormFieldProps
    extends Omit<TextFormFieldProps, keyof TextFormFieldPresentationProps>,
        LastNameFormFieldPresentationProps {
    prefill?: boolean;
}

export interface LastNameFormFieldStyles {
    textFormField?: TextFormFieldPresentationProps;
}

export const lastNameFormFieldStyles: LastNameFormFieldStyles = {};

const LastNameFormField: FC<LastNameFormFieldProps> = ({
    extendedStyles,
    overridedStyles,
    prefill,
    prefillValue,
    ...textFormFieldProps
}) => {
    const styles = useExpandProps(lastNameFormFieldStyles, extendedStyles, overridedStyles);
    const session = useAppSelector(state => state.context.session);

    return (
        <TextFormField
            {...styles.textFormField}
            label={translate(`${lastNameFormFieldLabelKey}`)}
            {...textFormFieldProps}
            prefillValue={prefill ? session.lastName : prefillValue}
        />
    );
};

export default LastNameFormField;
